import { render, staticRenderFns } from "./LogisticsModal.vue?vue&type=template&id=f7feb900&scoped=true&"
import script from "./LogisticsModal.vue?vue&type=script&lang=js&"
export * from "./LogisticsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7feb900",
  null
  
)

export default component.exports